import { render, staticRenderFns } from "./commonList.vue?vue&type=template&id=7b83d51c&scoped=true&"
import script from "./commonList.vue?vue&type=script&lang=js&"
export * from "./commonList.vue?vue&type=script&lang=js&"
import style0 from "./commonList.vue?vue&type=style&index=0&id=7b83d51c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b83d51c",
  null
  
)

export default component.exports